var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 960 540",
    width: "100%",
    height: "100%",
    preserveAspectRatio: "xMidYMax slice",
    xmlns: "http://www.w3.org/2000/svg",
    className: "absolute inset-0 pointer-events-none ng-tns-c131-1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 100,
    className: "text-gray-700 opacity-25 ng-tns-c131-1"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 234,
    cx: 196,
    cy: 23,
    className: "ng-tns-c131-1"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 234,
    cx: 790,
    cy: 491,
    className: "ng-tns-c131-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircles);
export default __webpack_public_path__ + "static/media/circles.73bb65910c326de1b56d3dab06ced47e.svg";
export { ForwardRef as ReactComponent };